import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Получение детальной информации о сервисе по его shopItemId
 * @param {number} shopItemId - id сервиса
 *
 * {@link https://master.api-vas.sandbox.d2c.r-one.io/docs/#/Vas/VasController_findOneByShopItemId Documentation}
 */
export const byShopItemId = (shopItemId: number): IRequest => ({
    uri: `/api/v1/vas/${shopItemId}`,
    method: 'GET',
    withAuth: true,
    withProvider: true,
});
